// extracted by mini-css-extract-plugin
export default {"safety":"safety___d3015e393f28f8f9994f","name":"name___f9d8130d3ae08e41f87b"};